import { Link } from "react-router-dom";

export default function NotAuthenticated(){
    return (
        <div className="NotAuthenticated">
            <div className="content">Debes iniciar sesión para consultar la información</div>
            <Link to="/login"><button className="btn btn-secondary">Entrar</button></Link>
        </div>
    )
}